import React from 'react';
import {TableContext, TableContextValue} from '../Table/TableContext';

export interface TableBodyProps extends React.HTMLAttributes<HTMLTableSectionElement> {}

const contextValue: TableContextValue = {variant: 'body'};

/** @component */
export const TableBodyBase: React.FunctionComponent<TableBodyProps> = props => (
    <TableContext.Provider value={contextValue}>
        <tbody {...props} />
    </TableContext.Provider>
);
